export default "__VITE_ASSET__BIvPnfxT__"